<template>
  <div>
    <v-container fluid>
      <v-row>
        <v-col md="6">
          <v-img src="./../assets/detection_03.jpg">
            <div class="d-flex">
              <v-spacer></v-spacer>
              <v-chip-group mandatory active-class="primary">
                <v-chip v-for="cameraType in cameraTypes" :key="cameraType">
                  {{ cameraType }}
                </v-chip>
              </v-chip-group>
            </div>
          </v-img>
          <v-card tile>
            <v-progress-linear :value="50" class="my-0" height="3"></v-progress-linear>

            <v-list>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>Main Camera Playback</v-list-item-title>
                  <v-list-item-subtitle>Recorded: Feb 9, 2024, 3:00 PM - 4:30 PM</v-list-item-subtitle>
                </v-list-item-content>

                <v-spacer></v-spacer>

                <v-list-item-icon>
                  <v-btn icon>
                    <v-icon>mdi-rewind</v-icon>
                  </v-btn>
                </v-list-item-icon>

                <v-list-item-icon :class="{ 'mx-5': $vuetify.breakpoint.mdAndUp }">
                  <v-btn icon>
                    <v-icon>mdi-pause</v-icon>
                  </v-btn>
                </v-list-item-icon>

                <v-list-item-icon class="ml-0" :class="{ 'mr-3': $vuetify.breakpoint.mdAndUp }">
                  <v-btn icon>
                    <v-icon>mdi-fast-forward</v-icon>
                  </v-btn>
                </v-list-item-icon>
              </v-list-item>
            </v-list>
          </v-card>
        </v-col>
        <v-col md="6">
          <div class="d-flex">
            <h3 class="display-1 font-weight-bold">
              <v-icon left>mdi-eye</v-icon> Scene Insights
            </h3>
            <v-spacer></v-spacer>
            <span>
              <v-btn @click="$emit('close')" icon>
                <v-icon large>mdi-close</v-icon>
              </v-btn>
            </span>
          </div>
          <div>
          </div>
          <v-row>
            <v-col md="12">
              <div class="text-grey overline">ANALYSIS</div>
              <span class="body-1">
                Humans with guns appear to move towards border.
              </span>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col md="3">
              <v-card class="pa-1" outlined>
                <v-card-text>
                  <div class="d-flex align-center">
                    <div class="text-center">
                      <v-icon color="grey" large>mdi-account-multiple</v-icon>
                      <h4 class="overline d-flex align-center">
                        <span>HUMANS</span>
                      </h4>
                    </div>
                    <v-spacer></v-spacer>
                    <div>
                      <h5 class="display-2 font-weight-bold d-inline white--text mr-2">
                        3
                      </h5>
                    </div>
                  </div>
                  <div class="body-2 font-weight-bold">
                    87% Confidence
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col md="3">
              <v-card class="pa-1" outlined>
                <v-card-text>
                  <div class="d-flex align-center">
                    <div class="text-center">
                      <v-icon color="grey" large>mdi-pistol</v-icon>
                      <h4 class="overline d-flex align-center">
                        <span>WEAPONS</span>
                      </h4>
                    </div>
                    <v-spacer></v-spacer>
                    <div>
                      <h5 class="display-2 font-weight-bold d-inline white--text mr-2">
                        3
                      </h5>
                    </div>
                  </div>
                  <div class="body-2 font-weight-bold">
                    79% Confidence
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col md="3">
              <v-card class="pa-1" outlined>
                <v-card-text>
                  <div class="d-flex align-center">
                    <div class="text-center">
                      <v-icon color="grey" large>mdi-car-back</v-icon>
                      <h4 class="overline d-flex align-center">
                        <span>VEHICLES</span>
                      </h4>
                    </div>
                    <v-spacer></v-spacer>
                    <div>
                      <h5 class="display-2 font-weight-bold d-inline white--text mr-2">
                        0
                      </h5>
                    </div>
                  </div>
                  <div class="body-2 font-weight-bold">
                    89% Confidence
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col md="3">
              <v-card class="pa-1" outlined>
                <v-card-text>
                  <div class="d-flex align-center">
                    <div class="text-center">
                      <v-icon color="grey" large>mdi-quadcopter</v-icon>
                      <h4 class="overline d-flex align-center">
                        <span>DRONES</span>
                      </h4>
                    </div>
                    <v-spacer></v-spacer>
                    <div>
                      <h5 class="display-2 font-weight-bold d-inline white--text mr-2">
                        0
                      </h5>
                    </div>
                  </div>
                  <div class="body-2 font-weight-bold">
                    92% Confidence
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col md="6">
              <v-card class="pa-1" outlined>
                <v-card-text>
                  <div class="d-flex align-center">
                    <div class="text-center">
                      <v-icon color="grey" large>mdi-map-marker</v-icon>
                      <h4 class="overline d-flex align-center">
                        <span>LOCATION</span>
                      </h4>
                    </div>
                    <v-spacer></v-spacer>
                    <div>
                      <h5 class="display-1 font-weight-bold d-inline white--text mr-2">
                        10°N 30°E
                      </h5>
                      <div class="body-2 font-weight-bold mt-2">
                        P110 - P111 <v-btn class="ml-5" outlined color="primary" small>View In Map</v-btn>
                      </div>
                    </div>
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col md="6">
              <v-card class="pa-1" outlined>
                <v-card-text>
                  <div class="d-flex align-center">
                    <div>
                      <v-icon color="grey" large>mdi-head-snowflake</v-icon>
                      <h4 class="overline d-flex align-center">
                        <span>INTENT</span>
                      </h4>
                    </div>
                    <v-spacer></v-spacer>
                    <div>
                      <h5 class="display-2 font-weight-bold d-inline red--text mr-2">
                        -
                      </h5>
                    </div>
                  </div>
                  <div class="body-2 font-weight-bold">
                    85% Confidence
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col md="12">
              <v-divider class="my-4"></v-divider>
              <div class="text-grey overline mb-5">ACTION</div>
              <v-btn color="primary" large>SEND SURVEILLIANCE BOT</v-btn>
              <!-- <v-btn class="ml-3" large>MARK AS FALSE POSITIVE</v-btn> -->
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  data: () => ({
    cameraTypes: ['RGB', 'IR', 'Infrared']
  })
}
</script>